import logo from "../../../assets/appcharge-logo.png";
import { Stack, Typography } from "@mui/material";

export const LogoMain = ({ width }) => {
  return (
    <Stack mt={2} justifyContent="center" alignItems="center">
      <img src={logo} alt="icon logo" width="150px" />
      <Typography variant="h6" fontSize="12px" mt={0.5} color="gray">
        React SDK Test Store
      </Typography>
    </Stack>
  );
};
